export default {
    "DeFi Binance": "DeFi Binance",
    "流动性挖矿": "Minería de liquidez",
    "加入节点， 开始挖矿": "Únete al nodo, empieza a minar",
    "参 与": "Participar",
    "矿池数据": "Datos del pool",
    "总产量": "Producción total",
    "有效节点": "Nodos activos",
    "参与者": "Participantes",
    "用户收入": "Ingresos del usuario",
    "挖矿榜单": "Clasificación de minería",
    "流动性挖矿收入": "Ingresos por minería de liquidez",
    "输出记录": "Registro de salidas",
    "地址": "Dirección",
    "数量": "Cantidad",
    "帮助中心": "Centro de ayuda",
    "希望它可以帮助你": "Esperamos que te ayude",
    "安全保障": "Garantía de seguridad",
    "我们有安全的审计报告": "Contamos con auditorías de seguridad",
    "伙伴": "Socios",
    "我们的商业伙伴": "Nuestros socios comerciales",
    "首页": "Inicio",
    "我的矿池": "Mi pool",
    "提取": "Retirar",
    "账户": "Cuenta",
    "总挖矿金额": "Monto total minado",
    "可更换": "Intercambiable",
    "收益率": "Rentabilidad",
    "币池名称": "Nombre del pool",
    "最低金额": "Monto mínimo",
    "收益率/24小时": "Rentabilidad/24h",
    "挖矿记录": "Historial de minería",
    "金额": "Monto",
    "描述": "Descripción",
    "时间": "Hora",
    "已参与": "Participado",
    "质 押": "Staking",
    "已质押": "En staking",
    "记录": "Registro",
    "兑换": "Convertir",
    "从": "De",
    "全部": "Todo",
    "至": "A",
    "价格": "Precio",
    "确认": "Confirmar",
    "矿池收益": "Ingresos del pool",
    "今日收益": "Ingresos de hoy",
    "普通矿池": "Pool estándar",
    "高级矿池": "Pool avanzado",
    "全部的": "Todos",
    "可用的": "Disponible",
    "申请加入": "Solicitar ingreso",
    "推荐朋友": "Recomendar a amigos",
    "一起赚取加密货币": "Gana cripto juntos",
    "查看详情": "Ver detalles",
    "团队": "Equipo",
    "推荐": "Referencia",
    "团队规模": "Tamaño del equipo",
    "直接发起人": "Patrocinador directo",
    "总收入": "Ingresos totales",
    "今天的收入": "Ingresos de hoy",
    "我的推荐链接": "Mi enlace de referencia",
    "复制": "Copiar",
    "1. 获取链接": "1. Obtén el enlace",
    "2. 邀请朋友": "2. Invita a tus amigos",
    "3. 赚取加密货币": "3. Gana criptomonedas",
    "等级": "Nivel",
    "1 级": "Nivel 1",
    "2 级": "Nivel 2",
    "3 级": "Nivel 3",
    "用户地址": "Dirección del usuario",
    "币种": "Token",
    "说明": "Detalles",
    "状态": "Estado",
    "定时收益": "Ingresos programados",
    "今日预收益": "Ingresos previstos hoy",
    "累计收益": "Ingresos acumulados",
    "将矿池收益的BNB兑换成USDT后立即到账": "Convierte ingresos en BNB a USDT al instante",
    "将USDT提取后会在24小时内到达你的钱包": "El retiro de USDT llegará en 24 horas",
    "天": "Días",
    "高级矿池收益": "Ingresos del pool avanzado",
    "质押收益": "Ingresos por staking",
    "下次收益": "Próximos ingresos",
    "当前收益率": "Rentabilidad actual",
    "昨日收益": "Ingresos de ayer",
    "普通矿池收益率": "Rentabilidad del pool estándar",
    "高级矿池收益率": "Rentabilidad del pool avanzado",
    "高级矿池限时开放": "Pool avanzado abierto por tiempo limitado",
	"公告":"anuncio",
	"我知道了":"DE ACUERDO"
};
